import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { IExtendedFilterValue } from "@app/interfaces/dtos/IExtendedFilterValue";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { RouteLocation } from "vue-router";
import { IExtendedWithPortalTypeFilterValue } from "./IExtendedWithPortalTypeFilterValue";
import { ProgrammeSortType } from "@studyportals/search-api-interface";
import { SearchType } from "@domain/enums/SearchType";

export const UNIVERSITY_RANKINGS_SORT = 'rankings';
const UNIVERSITY_RANKINGS_PATH_REGEX = /^\/(?:search|omni-search\/search)\/universities\/[^/]+\/rankings(?:\/|$)/;

export class SortMapper extends FilterMapper {
	public filterType: FilterType = FilterType.SORTING;
	public isMultiSelect = false;
	private static instance: SortMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{
			id: ProgrammeSortType.DEFAULT,
			name: 'Recommended',
			excludedForSearchTypes: [SearchType.UNIVERSITY_SEARCH, SearchType.SCHOLARSHIP_SEARCH]
		},
		{
			id: ProgrammeSortType.TUITION,
			name: 'Low tuition fee',
			excludedForSearchTypes: [SearchType.UNIVERSITY_SEARCH, SearchType.SCHOLARSHIP_SEARCH]
		},
		{
			id: UNIVERSITY_RANKINGS_SORT,
			name: 'Rankings',
			virtualPath: UNIVERSITY_RANKINGS_SORT,
			excludedForSearchTypes: [SearchType.PROGRAMME_SEARCH, SearchType.SCHOLARSHIP_SEARCH]
		}
	];

	public static getInstance(): SortMapper {
		if (!SortMapper.instance) {
			SortMapper.instance = new SortMapper();
		}
		return SortMapper.instance;
	}

	private constructor() {
		super();
	}

	public canBeIndexed(): boolean {
		return false;
	}

	public override getExtendedFilterValuesFromRoute(route: RouteLocation): Promise<IExtendedFilterValue[]> {
		if (this.isUniversityRankingsRoute(route.path)) {
			return Promise.resolve([this.values[2]!]);
		}

		const queryKeyword = route.query?.[this.filterType];

		if (typeof queryKeyword === 'string' && queryKeyword.length > 0) {
			const filterValue = this.createExtendedFilterValue(queryKeyword);
			return Promise.resolve(filterValue ? [filterValue] : []);
		}

		return Promise.resolve([]);
	}

	private createExtendedFilterValue(sortType: string): IExtendedFilterValue | undefined {
		const text = sortType.trim();

		if (text.length === 0) return undefined;
		const knownValue = this.values.find(v => v.id === text || v.virtualPath === text);
		if (knownValue) return knownValue;

		return {
			id: text
		};
	}

	private isUniversityRankingsRoute(path?: string): boolean {
		return !!path && UNIVERSITY_RANKINGS_PATH_REGEX.test(path);
	}
}